export const WEDGE = 'wedge';
export const DASHED = 'dashed';
export const DOTTED = 'DOTTED';
export const CIS = 'CIS';
export const TRANS = 'TRANS';

export const DEFAULT_CHANGE_COLOR = '#00000060';
export const SELECT_COLOR = '#34c2c3';
export const DEFAULT_RANDOM_SEED = 0;
